import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AddAddress, CartUpdatedV2, ChangeShippingAddress } from "@faire/retailer-visitor-shared/events";
import { createCartItemForFixCart } from "@faire/retailer-visitor-shared/lib/fixCartItemsV2";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { fromPromiseWithOldValue } from "@faire/retailer-visitor-shared/lib/mobxHelpers";
import { stringOrUndefined } from "@faire/retailer-visitor-shared/lib/stringOrUndefined";
import { webSocketUrls } from "@faire/retailer-visitor-shared/lib/webSocketUrls";
import { getCartToken } from "@faire/retailer-visitor-shared/serialized-data/getCartToken";
import { getCartItemFixes } from "@faire/retailer-visitor-shared/stores/domain/CartStore/fixCart";
import { WebSocketChannelStore } from "@faire/retailer-visitor-shared/stores/WebSocketChannelStore";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { fulfilledOrStale } from "@faire/web--source/common/instanceUtils";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import fixCartIssues from "@faire/web-api--source/api/v2/carts/cartToken/fix-issues/post";
import getCart, { QueryParameters as CartParameters } from "@faire/web-api--source/api/v2/carts/cartToken/get";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { ICartV2 } from "@faire/web-api--source/faire/carts/ICartV2";
import { IFixCartItemIssuesRequestV2 } from "@faire/web-api--source/faire/carts/IFixCartItemIssuesRequestV2";
import { IGetCartRequest } from "@faire/web-api--source/faire/carts/IGetCartRequest";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import cloneDeep from "lodash/cloneDeep";
import flatten from "lodash/flatten";
import intersection from "lodash/intersection";
import isEmpty from "lodash/isEmpty";
import { computed, action, observable } from "mobx";
import { fromPromise, PENDING } from "mobx-utils";
import qs from "query-string";
export var CheckoutCartStore = /*#__PURE__*/ function() {
    "use strict";
    function CheckoutCartStore() {
        var _this = this;
        _class_call_check(this, CheckoutCartStore);
        var _this1 = this;
        var _stringOrUndefined;
        this.checkoutCartWebSocket = undefined;
        this.initialLoad = true;
        this.pendingCartItems = new Map();
        this.forbiddenBrandTokens = [];
        this.websocket = undefined;
        this.shouldExcludeAlcoholDisclaimers = false;
        this.updateCartFn = undefined;
        var _stringOrUndefined_split;
        this.brandTokens = (_stringOrUndefined_split = (_stringOrUndefined = stringOrUndefined(qs.parse(getLocationOrThrow().search).brands)) === null || _stringOrUndefined === void 0 ? void 0 : _stringOrUndefined.split(",")) !== null && _stringOrUndefined_split !== void 0 ? _stringOrUndefined_split : [];
        this.setUpdateCartFn = function(updateCartFn) {
            _this.updateCartFn = updateCartFn;
        };
        this.resetAllFields = function() {
            _this.updateCartFn = undefined;
            _this.brandTokens = [];
            _this.cartSummaryResponse = undefined;
            _this.filters = undefined;
            _this.cartResponse = undefined;
            _this.activeBrandCartsResponse = undefined;
            _this.savedBrandCartsResponse = undefined;
            _this.initialLoad = true;
            _this.pendingCartItems.clear();
        };
        this.initCheckout = function() {
            var _WebSocketChannelStore_get_getOrInitChannel;
            _this.checkoutCartWebSocket = (_WebSocketChannelStore_get_getOrInitChannel = WebSocketChannelStore.get().getOrInitChannel(webSocketUrls.retailerNotification())) === null || _WebSocketChannelStore_get_getOrInitChannel === void 0 ? void 0 : _WebSocketChannelStore_get_getOrInitChannel.subscribe(_this.handleDutiesUpdate);
            AddAddress.subscribe(_this.refreshCheckoutCart);
            ChangeShippingAddress.subscribe(_this.refreshCheckoutCart);
            _this.init();
        };
        this.cleanupCheckout = function() {
            _this.cleanup();
            if (_this.checkoutCartWebSocket !== undefined) {
                var _WebSocketChannelStore_get_getOrInitChannel;
                (_WebSocketChannelStore_get_getOrInitChannel = WebSocketChannelStore.get().getOrInitChannel(webSocketUrls.retailerNotification())) === null || _WebSocketChannelStore_get_getOrInitChannel === void 0 ? void 0 : _WebSocketChannelStore_get_getOrInitChannel.unsubscribe(_this.checkoutCartWebSocket);
            }
            AddAddress.unsubscribe(_this.refreshCheckoutCart);
            ChangeShippingAddress.unsubscribe(_this.refreshCheckoutCart);
            _this.resetAllFields();
        };
        this.refreshCheckoutCart = function() {
            _this.refreshCart();
        };
        this.refreshCheckoutCartWithShippingMethodType = function(selectedShippingMethodType) {
            return _this.refreshCart({
                selectedShippingMethodType: selectedShippingMethodType
            });
        };
        this.updateCheckoutItems = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(items, options) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.initialLoad = false;
                            return [
                                4,
                                _this1.updateCartData(items, options)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(items, options) {
                return _ref.apply(this, arguments);
            };
        }();
        this.updateCheckoutShippingDate = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(requestedShipDates) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.initialLoad = false;
                            return [
                                4,
                                _this1.updateCartData([], {
                                    upltParams: {
                                        event: "none"
                                    }
                                }, undefined, requestedShipDates)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(requestedShipDates) {
                return _ref.apply(this, arguments);
            };
        }();
        this.fixCheckoutCart = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(items) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(items === null || items === void 0 ? void 0 : items.length)) {
                                return [
                                    2
                                ];
                            }
                            _this1.initialLoad = false;
                            return [
                                4,
                                _this1.fixCartAndUpdateData(items)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(items) {
                return _ref.apply(this, arguments);
            };
        }();
        this.handleDutiesUpdate = function(message) {
            if (message.type === IWebSocketMessage.Type.CART_DUTIES_UPDATED) {
                _this.refreshCart();
            }
        };
        /** CartViewState methods */ this.cleanup = function() {
            if (_this.websocket !== undefined) {
                var _WebSocketChannelStore_get_getOrInitChannel;
                (_WebSocketChannelStore_get_getOrInitChannel = WebSocketChannelStore.get().getOrInitChannel(webSocketUrls.retailerNotification())) === null || _WebSocketChannelStore_get_getOrInitChannel === void 0 ? void 0 : _WebSocketChannelStore_get_getOrInitChannel.unsubscribe(_this.websocket);
            }
        };
        this.clearPendingCartItems = function() {
            _this.pendingCartItems.clear();
        };
        this.getCartRequest = function(savedForLater) {
            var _this_brandTokens;
            return IGetCartRequest.build({
                filter_brand_carts_by_keys: _this.filterKeys,
                brand_tokens: (_this_brandTokens = _this.brandTokens) !== null && _this_brandTokens !== void 0 ? _this_brandTokens : [],
                sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
                exclude_alcohol_disclaimer: _this.shouldExcludeAlcoholDisclaimers,
                saved_for_later: savedForLater,
                should_collapse_preorder_groups: undefined
            });
        };
        this.init = function(options, parallelizeSavedAndActiveBrands) {
            if (!isLoggedInRetailer()) {
                return;
            }
            _this.filters = options === null || options === void 0 ? void 0 : options.filters;
            // Filtering by brand cart tokens takes precedence on the backend
            // over filtering by active or saved brand cart state
            if (!parallelizeSavedAndActiveBrands || _this.brandTokens) {
                _this.cartResponse = fromPromise(getCart(getCartToken(), CartParameters.build(_this.getCartRequest())).catch(function() {
                    return undefined;
                }));
                return;
            }
            _this.savedBrandCartsResponse = fromPromise(getCart(getCartToken(), CartParameters.build(_this.getCartRequest(true))).catch(function() {
                return undefined;
            }));
            _this.activeBrandCartsResponse = fromPromise(getCart(getCartToken(), CartParameters.build(_this.getCartRequest(false))).then(function(data) {
                return data;
            }).catch(function() {
                return undefined;
            }));
        };
        this.refreshCart = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(options) {
                var _this_cartResponse, oldCart, _this_brandTokens, promise;
                return _ts_generator(this, function(_state) {
                    if (!isLoggedInRetailer()) {
                        return [
                            2
                        ];
                    }
                    _this1.filters = options === null || options === void 0 ? void 0 : options.filters;
                    oldCart = (_this_cartResponse = _this1.cartResponse) === null || _this_cartResponse === void 0 ? void 0 : _this_cartResponse.case({});
                    promise = getCart(getCartToken(), CartParameters.build({
                        filter_brand_carts_by_keys: _this1.filterKeys,
                        brand_tokens: (_this_brandTokens = _this1.brandTokens) !== null && _this_brandTokens !== void 0 ? _this_brandTokens : [],
                        sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
                        shipping_method_type: options === null || options === void 0 ? void 0 : options.selectedShippingMethodType,
                        exclude_alcohol_disclaimer: _this1.shouldExcludeAlcoholDisclaimers,
                        should_collapse_preorder_groups: undefined
                    })).catch(function() {
                        return oldCart;
                    });
                    _this1.cartResponse = fromPromiseWithOldValue(promise, _this1.cartResponse);
                    return [
                        2
                    ];
                });
            });
            return function(options) {
                return _ref.apply(this, arguments);
            };
        }();
        this.getUpdatedCarts = function(items, updatedCartResponse) {
            var _this_cartData_brand_carts, _this_cartData, _this_cartData1;
            var currentFilterSections = cloneDeep(_this.filterSections);
            var updatedOrDeletedBrandTokens = new Set();
            items.forEach(function(item) {
                updatedOrDeletedBrandTokens.add(item.brand_token);
            });
            updatedCartResponse === null || updatedCartResponse === void 0 ? void 0 : updatedCartResponse.brand_carts.forEach(function(cart) {
                updatedOrDeletedBrandTokens.add(cart.brand_token);
            });
            var activeCarts = (_this_cartData = _this.cartData) === null || _this_cartData === void 0 ? void 0 : (_this_cartData_brand_carts = _this_cartData.brand_carts) === null || _this_cartData_brand_carts === void 0 ? void 0 : _this_cartData_brand_carts.filter(function(cart) {
                return !updatedOrDeletedBrandTokens.has(cart.brand_token);
            });
            var _updatedCartResponse_brand_carts;
            var brandCarts = _to_consumable_array((_updatedCartResponse_brand_carts = updatedCartResponse === null || updatedCartResponse === void 0 ? void 0 : updatedCartResponse.brand_carts) !== null && _updatedCartResponse_brand_carts !== void 0 ? _updatedCartResponse_brand_carts : []).concat(_to_consumable_array(activeCarts !== null && activeCarts !== void 0 ? activeCarts : []));
            _this.clearPendingCartItems();
            return ICartV2.build({
                cart_stats: (_this_cartData1 = _this.cartData) === null || _this_cartData1 === void 0 ? void 0 : _this_cartData1.cart_stats,
                token: updatedCartResponse === null || updatedCartResponse === void 0 ? void 0 : updatedCartResponse.token,
                brand_carts: brandCarts,
                filter_sections: currentFilterSections
            });
        };
        this.updateCartData = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(items, options, brand_carts, requested_ship_dates) {
                var _this_cartResponse, _this_updateCartFn, _this, oldCart, promise;
                return _ts_generator(this, function(_state) {
                    oldCart = (_this_cartResponse = _this1.cartResponse) === null || _this_cartResponse === void 0 ? void 0 : _this_cartResponse.case({});
                    promise = (_this_updateCartFn = (_this = _this1).updateCartFn) === null || _this_updateCartFn === void 0 ? void 0 : _this_updateCartFn.call(_this, {
                        items: items,
                        allowEmptyItems: true,
                        brand_carts: brand_carts,
                        requested_ship_dates: requested_ship_dates,
                        should_collapse_preorder_groups: undefined,
                        upltParams: options.upltParams
                    }).then(function(response) {
                        return _this1.getUpdatedCarts(items, response);
                    }).catch(function() {
                        _this1.clearPendingCartItems();
                        return oldCart;
                    });
                    if (promise) {
                        _this1.cartResponse = fromPromiseWithOldValue(promise, _this1.cartResponse);
                    }
                    return [
                        2,
                        promise
                    ];
                });
            });
            return function(items, options, brand_carts, requested_ship_dates) {
                return _ref.apply(this, arguments);
            };
        }();
        this.fixCartAndUpdateData = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(items) {
                var _this_cartResponse, itemsToFix, oldCart, promise;
                return _ts_generator(this, function(_state) {
                    itemsToFix = flatten(items.map(function(item) {
                        return getCartItemFixes(createCartItemForFixCart(item));
                    }));
                    oldCart = (_this_cartResponse = _this1.cartResponse) === null || _this_cartResponse === void 0 ? void 0 : _this_cartResponse.case({});
                    promise = fixCartIssues(getCartToken(), IFixCartItemIssuesRequestV2.build({
                        cart_item_fixes: itemsToFix
                    })).then(function(response) {
                        CartUpdatedV2.publish({});
                        return ICartV2.build({
                            token: getCartToken(),
                            brand_carts: response.brand_carts
                        });
                    }).catch(function() {
                        return oldCart;
                    });
                    _this1.cartResponse = fromPromiseWithOldValue(promise, _this1.cartResponse);
                    return [
                        2,
                        promise
                    ];
                });
            });
            return function(items) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setForbiddenBrandTokens = function(forbiddenBrandTokens) {
            _this.forbiddenBrandTokens = forbiddenBrandTokens;
        };
        this.mergeCartArrays = function(activeItems, savedItems, getKey) {
            var uniqueItemsMap = new Map();
            (activeItems !== null && activeItems !== void 0 ? activeItems : []).forEach(function(item) {
                uniqueItemsMap.set(getKey(item), item);
            });
            (savedItems !== null && savedItems !== void 0 ? savedItems : []).forEach(function(item) {
                if (!uniqueItemsMap.has(getKey(item))) {
                    uniqueItemsMap.set(getKey(item), item);
                }
            });
            return Array.from(uniqueItemsMap.values());
        };
        this.mergedBrandCarts = function(activeCart, savedCart) {
            return _this.mergeCartArrays(activeCart === null || activeCart === void 0 ? void 0 : activeCart.brand_carts, savedCart === null || savedCart === void 0 ? void 0 : savedCart.brand_carts, function(cart) {
                return cart.brand_token;
            });
        };
        this.mergedFilterSections = function(activeCart, savedCart) {
            return _this.mergeCartArrays(activeCart === null || activeCart === void 0 ? void 0 : activeCart.filter_sections, savedCart === null || savedCart === void 0 ? void 0 : savedCart.filter_sections, function(section) {
                return section.field_name;
            });
        };
        this.excludeAlcoholDisclaimers = function() {
            if (_this.shouldExcludeAlcoholDisclaimers !== true) {
                _this.shouldExcludeAlcoholDisclaimers = true;
            }
        };
        makeObservable(this);
        // In checkout confirmation page, we see the alcohol disclaimer in checkout summary
        // So, we don't need to include them for each brand cart
        this.excludeAlcoholDisclaimers();
    }
    _create_class(CheckoutCartStore, [
        {
            key: "isCheckoutCartLoadingOrUpdating",
            get: function get() {
                return this.isCartLoading;
            }
        },
        {
            key: "isCheckoutCartLoading",
            get: function get() {
                return this.isCartLoading && this.initialLoad;
            }
        },
        {
            key: "cartItems",
            get: function get() {
                if (this.isCheckoutCartLoadingOrUpdating) {
                    return undefined;
                }
                return this.checkoutCartBrands.flatMap(function(brand) {
                    return Object.values(brand.cart_items);
                }).filter(isNotUndefined);
            }
        },
        {
            key: "cartToken",
            get: function get() {
                return getCartToken();
            }
        },
        {
            key: "cartBrandTokens",
            get: function get() {
                return this.brandTokens;
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                if (this.cartItems === undefined) {
                    return false;
                }
                return isEmpty(this.cartItems);
            }
        },
        {
            key: "checkoutCartBrands",
            get: function get() {
                return this.improvedCartBrands.filter(function(brand) {
                    return brand.state === IBrandCartV2.State.READY_FOR_CHECKOUT;
                });
            }
        },
        {
            key: "filterKeys",
            get: function get() {
                var _this_filters;
                var _this_filters_split;
                return (_this_filters_split = (_this_filters = this.filters) === null || _this_filters === void 0 ? void 0 : _this_filters.split(",")) !== null && _this_filters_split !== void 0 ? _this_filters_split : [];
            }
        },
        {
            key: "activeCartLoading",
            get: function get() {
                return (!this.activeBrandCartsResponse || this.activeBrandCartsResponse.state === PENDING) && this.isFullCartLoading;
            }
        },
        {
            key: "isCartLoading",
            get: // Cart is considered loaded if we've either loaded the full cart, or loaded the
            // active cart, regardless of whether the saved for later cart is still loading
            function get() {
                return this.isFullCartLoading && this.activeCartLoading;
            }
        },
        {
            key: "isFullCartLoading",
            get: function get() {
                return !this.cartResponse || this.cartResponse.state === PENDING;
            }
        },
        {
            key: "cartSummary",
            get: function get() {
                return fulfilledOrStale(this.cartSummaryResponse, "brand_cart_summaries");
            }
        },
        {
            key: "mergedSavedAndActiveCart",
            get: function get() {
                var activeCart = fulfilledOrStale(this.activeBrandCartsResponse, "brand_carts");
                var savedCart = fulfilledOrStale(this.savedBrandCartsResponse, "brand_carts");
                return ICartV2.build({
                    token: activeCart === null || activeCart === void 0 ? void 0 : activeCart.token,
                    brand_carts: this.mergedBrandCarts(activeCart, savedCart),
                    filter_sections: this.mergedFilterSections(activeCart, savedCart),
                    cart_stats: activeCart === null || activeCart === void 0 ? void 0 : activeCart.cart_stats,
                    eori_checkout_content: activeCart === null || activeCart === void 0 ? void 0 : activeCart.eori_checkout_content
                });
            }
        },
        {
            key: "cartData",
            get: function get() {
                var fullCartData = fulfilledOrStale(this.cartResponse, "brand_carts");
                if (fullCartData || this.activeCartLoading) {
                    return fullCartData;
                }
                return this.mergedSavedAndActiveCart;
            }
        },
        {
            key: "brandCarts",
            get: function get() {
                var _this_cartData;
                var _this_cartData_brand_carts;
                return (_this_cartData_brand_carts = (_this_cartData = this.cartData) === null || _this_cartData === void 0 ? void 0 : _this_cartData.brand_carts) !== null && _this_cartData_brand_carts !== void 0 ? _this_cartData_brand_carts : [];
            }
        },
        {
            key: "filterSections",
            get: function get() {
                var _this_cartData;
                var _this_cartData_filter_sections;
                return (_this_cartData_filter_sections = (_this_cartData = this.cartData) === null || _this_cartData === void 0 ? void 0 : _this_cartData.filter_sections) !== null && _this_cartData_filter_sections !== void 0 ? _this_cartData_filter_sections : [];
            }
        },
        {
            key: "improvedCartBrands",
            get: function get() {
                var _this = this;
                var _this_brandCarts;
                return ((_this_brandCarts = this.brandCarts) !== null && _this_brandCarts !== void 0 ? _this_brandCarts : []).map(function(brand) {
                    var _this_cartSummary_brand_cart_summaries, _this_cartSummary;
                    var _brand_brand_token;
                    return _object_spread_props(_object_spread({}, brand), {
                        checkout_summary: (_this_cartSummary = _this.cartSummary) === null || _this_cartSummary === void 0 ? void 0 : (_this_cartSummary_brand_cart_summaries = _this_cartSummary.brand_cart_summaries) === null || _this_cartSummary_brand_cart_summaries === void 0 ? void 0 : _this_cartSummary_brand_cart_summaries[(_brand_brand_token = brand.brand_token) !== null && _brand_brand_token !== void 0 ? _brand_brand_token : ""],
                        is_eori_missing: false
                    });
                });
            }
        },
        {
            key: "zipCodeProtectionViolations",
            get: function get() {
                if (getIsBrandPreview()) {
                    return [];
                }
                return intersection(this.forbiddenBrandTokens, this.improvedCartBrands.filter(function(improvedCartBrand) {
                    return !improvedCartBrand.saved_for_later;
                }).map(function(brand) {
                    return brand.brand_token;
                }).filter(isNotUndefined));
            }
        }
    ]);
    return CheckoutCartStore;
}();
CheckoutCartStore.get = singletonGetter(CheckoutCartStore);
__decorate([
    observable
], CheckoutCartStore.prototype, "cartSummaryResponse", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "filters", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "cartResponse", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "activeBrandCartsResponse", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "savedBrandCartsResponse", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "initialLoad", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "pendingCartItems", void 0);
__decorate([
    observable
], CheckoutCartStore.prototype, "forbiddenBrandTokens", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "initCheckout", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "cleanupCheckout", void 0);
__decorate([
    computed
], CheckoutCartStore.prototype, "isCheckoutCartLoadingOrUpdating", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "isCheckoutCartLoading", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "cartItems", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "cartToken", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "cartBrandTokens", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "isEmpty", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "checkoutCartBrands", null);
__decorate([
    action
], CheckoutCartStore.prototype, "refreshCheckoutCart", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "refreshCheckoutCartWithShippingMethodType", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "updateCheckoutItems", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "updateCheckoutShippingDate", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "fixCheckoutCart", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "cleanup", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "clearPendingCartItems", void 0);
__decorate([
    computed
], CheckoutCartStore.prototype, "filterKeys", null);
__decorate([
    action
], CheckoutCartStore.prototype, "init", void 0);
__decorate([
    action
], CheckoutCartStore.prototype, "refreshCart", void 0);
__decorate([
    computed
], CheckoutCartStore.prototype, "activeCartLoading", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "isCartLoading", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "isFullCartLoading", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "cartSummary", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "mergedSavedAndActiveCart", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "cartData", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "brandCarts", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "filterSections", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "improvedCartBrands", null);
__decorate([
    computed
], CheckoutCartStore.prototype, "zipCodeProtectionViolations", null);
export var useCheckoutCartStore = createStoreHook(CheckoutCartStore);
